const KIND = { riichi: 'RIICHI', tsumo: 'TSUMO' }

const MAP = {
  light: {
    base: 'inline-flex items-center text-[9px] font-bold tracking-[1px] rounded-[3px] px-[6px] py-[2px]',
    riichi: 'text-white bg-[#c0392b]',
    tsumo: 'text-[#3a2c07] bg-[#e2a93b]',
  },
  dark: {
    base: 'inline-flex items-center text-[9px] font-bold tracking-[1px] rounded-[3px] px-[6px] py-[2px]',
    riichi: 'text-white bg-[#c0392b]',
    tsumo: 'text-[#3a2c07] bg-[#e2a93b]',
  },
  industry: {
    base: 'inline-flex items-center font-heading text-[10px] font-semibold tracking-[2px] uppercase rounded-none px-2 py-[2px]',
    riichi: 'text-white bg-accent',
    tsumo: 'text-white bg-accent-900',
  },
}

export default function StatusBadge({ kind = 'riichi', theme = 'light' }) {
  const m = MAP[theme] || MAP.light
  return <span className={`${m.base} ${m[kind] || m.riichi}`}>{KIND[kind] || 'RIICHI'}</span>
}
